export const ClockIcon = () => {
	return (
		<svg width="20" height="20" viewBox="0 0 20 20" fill="none">
			<path
				d="M9.99999 18.9583C5.05832 18.9583 1.04166 14.9417 1.04166 10C1.04166 5.05833 5.05832 1.04167 9.99999 1.04167C14.9417 1.04167 18.9583 5.05833 18.9583 10C18.9583 14.9417 14.9417 18.9583 9.99999 18.9583ZM9.99999 2.29167C5.74999 2.29167 2.29166 5.75 2.29166 10C2.29166 14.25 5.74999 17.7083 9.99999 17.7083C14.25 17.7083 17.7083 14.25 17.7083 10C17.7083 5.75 14.25 2.29167 9.99999 2.29167Z"
				fill="white"
			/>
			<path
				d="M13.0917 13.275C12.9833 13.275 12.875 13.25 12.775 13.1833L10.1917 11.6417C9.55001 11.2583 9.07501 10.4167 9.07501 9.675V6.25834C9.07501 5.91667 9.35835 5.63334 9.70001 5.63334C10.0417 5.63334 10.325 5.91667 10.325 6.25834V9.675C10.325 9.975 10.575 10.4167 10.8333 10.5667L13.4167 12.1083C13.7167 12.2833 13.8083 12.6667 13.6333 12.9667C13.5083 13.1667 13.3 13.275 13.0917 13.275Z"
				fill="white"
			/>
		</svg>
	)
}
